import React from 'react';
import i18n from 'i18next';
import { Button, ModalCenter } from 'Components';
import './CrashScreen.css';

const CrashScreen = () => (
  <div className="crash-screen-modal">
    <ModalCenter>
      <div>{i18n.t('common:PageUnavailable')}</div>
      <div className="crash-screen-modal__description">{i18n.t('common:PageUnavailableDescription')}</div>
      <Button
        className="button--primary"
        onClick={() => window.location.reload()}
      >
        {i18n.t('common:refresh')}
      </Button>
    </ModalCenter>
  </div>
);

export default CrashScreen;



// WEBPACK FOOTER //
// ./src/components/CrashScreen/CrashScreen.jsx